import React from 'react';

import defaultImage from '../../assets/img/components/User/Login/pw-background-plane-shiny.png';

class ResourcesCard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <a
        target="_blank"
        rel="noopener noreferrer"
        href={
          this.props.item && this.props.item.link ? this.props.item.link : '#'
        }
      >
        <div className="resources-card-container-aux">
          <div className="top">
            <div
              className="card-img"
              height="160"
              width="519.66"
              style={{
                backgroundImage:
                  this.props.item.featured_media != null &&
                  this.props.item.featured_media != 0
                    ? `url(${this.props.item._embedded['wp:featuredmedia'][0].source_url})`
                    : `url(${defaultImage})`,
              }}
            />
          </div>

          {/* Middle part */}
          <div className="middle pl-4 pr-4 pb-5">
            {this.props.item.title.rendered}
          </div>

          {/* Bottom part */}
          <div className="divider" />
          <div className="bottom pt-3 pb-3 pl-4">
            <div className="bottom-text">
              READ MORE
              <i className="material-icons arrow ml-2">arrow_forward</i>
            </div>
          </div>
        </div>
      </a>
    );
  }
}

export default ResourcesCard;
